<svg width="327" height="209" viewBox="0 0 327 209" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 12C0 5.37258 5.37258 0 12 0H315C321.627 0 327 5.37258 327 12V197C327 203.627 321.627 209 315 209H12C5.37259 209 0 203.627 0 197V12Z" fill="white"/>
</svg>
